import { CardMedia } from '@customink/pigment-react';
import { OrderSummary } from '~/adapters/services/accounts/orders/types';
import { OrderProductsCarousel } from '../DesktopOrderContentRow/OrderProductsCarousel';

interface OrderCardMediaProps {
    order: OrderSummary;
}

export function OrderCardMedia({ order }: OrderCardMediaProps) {
    return (
        <CardMedia>
            <OrderProductsCarousel order={order} />
        </CardMedia>
    );
}
